export default [{
	path: 'personalCenter',
	component: () => import('../../views/platform/personalCenter/index.vue'),
	redirect: '/home/personalCenter/userInfo',
	meta: {
		title: '个人中心'
	},
	children: [
		// 个人信息
		{
			path: 'userInfo',
			component: () => import('../../views/platform/personalCenter/userInfo/index')
		},
		// 学情分析
		{
			path: 'studylogs',
			component: () => import('../../views/platform/personalCenter/studylogs/index'),
			redirect: '/home/personalCenter/studylogs/main',
			children: [
				{
					path: 'main',
					component: () => import('../../views/platform/personalCenter/studylogs/main')
				},
				{
					path: 'details',
					component: () => import('../../views/platform/personalCenter/studylogs/details')
				}
			]
		},
		// 模考记录
		{
			path: 'examlogs',
			component: () => import('../../views/platform/personalCenter/examPaperLogs/index')
		},
		// 登录记录
		{
			path: 'loginlogs',
			component: () => import('../../views/platform/personalCenter/loginLogs/index')
		},
		// 问题反馈
		{
			path: 'feedback',
			component: () => import('../../views/platform/personalCenter/feedback')
		},{
			path:'userCollection',
			component: () => import('../../views/platform/personalCenter/userCollection/index')
		},{
			path:'userDownload',
			component: () => import('../../views/platform/personalCenter/userDownload/index')
		}
	]
}]